import React from 'react';
import styled from '@emotion/styled';
import { useStoreState } from 'easy-peasy';
import Utils from '~/core/scripts/utils';

import * as S from './shared.styles.js';

function roundTo(number, nearest) {
  return Math.round(number / nearest) * nearest;
}

const CoronaNumbers = ({
  confirmed = 0,
  dailyConfirmed = 0,
  recovered = 0,
  deaths = 0,
  loading = false,
  roundToNearest = 50,
  showDailyConfirmed = false,
  filter,
  smallNumbers = false,
  showLabels = true,
}) => {
  const isTeaser = useStoreState((state) => state.app.isTeaser);

  const roundRecovered = roundTo(recovered, roundToNearest);

  const sourceText =
    filter === 'germany'
      ? 'inkl. vorläufige Meldungen und Korrekturen'
      : '<sup>*</sup>Keine offiziellen Angaben zu Genesenen';

  return (
    <>
      <S.Wrapper isLoading={loading} isTeaser={isTeaser}>
        <S.Item type="confirmed" isTeaser={isTeaser}>
          <S.Number isTeaser={isTeaser} isSmall={smallNumbers}>
            {Utils.numberFormat(confirmed)}
          </S.Number>
          {showLabels && (
            <S.Label>
              bestätigt{' '}
              {showDailyConfirmed && (
                <span title="Fälle seit 0 Uhr, inkl. vorläufige Meldungen und Korrekturen">
                  ({Utils.format('+,.0f')(dailyConfirmed)})
                </span>
              )}
            </S.Label>
          )}
        </S.Item>
        <S.Item type="recovered" isTeaser={isTeaser}>
          <S.Number isTeaser={isTeaser} isSmall={smallNumbers}>
            {recovered > 0 && <S.Prefix>≈</S.Prefix>}
            {Utils.numberFormat(roundRecovered)}
          </S.Number>
          {showLabels && <S.Label>genesen</S.Label>}
        </S.Item>
        <S.Item type="deaths" isTeaser={isTeaser}>
          <S.Number isTeaser={isTeaser} isSmall={smallNumbers}>
            {Utils.numberFormat(deaths)}
          </S.Number>
          {showLabels && <S.Label>Todesfälle</S.Label>}
        </S.Item>
      </S.Wrapper>
      {!isTeaser && sourceText && <S.Source dangerouslySetInnerHTML={{ __html: sourceText }} />}
    </>
  );
};

export default CoronaNumbers;
